import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { login } from '../../feature/AuthSlice';
import httpClient from '../../http/HttpRequest'
import { Link, useNavigate } from 'react-router-dom';
import {PARTNER_LOGIN} from '../../data/url'
import { useTranslation } from 'react-i18next';
import Alert from '../../feature/Alert';
import logo from '../../logo.png';

export default function Login() {
    
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [errors, setErrors] = useState({});   

    const { t } = useTranslation();

    const navigate = useNavigate();

    const dispatch = useDispatch();

    const handelSubmit = async (e) => {
        e.preventDefault();

        let formErrors = {};
        let valid = true;

        if (!username) {
            formErrors.username = 'username_required';
            valid = false;
        } else if (username.length !== 10) {
            formErrors.username = 'username_sb_10_digit';
            valid = false;
        } else if (isNaN(Number(username))) {
            formErrors.username = 'username_sb_containt_number';
            valid = false;
        }
        if (!password) {
            formErrors.password = 'password_required';
            valid = false;
        } else if (password.length < 6) {
            formErrors.password = 'password_required';
            valid = false;
        }
        if (valid) {
            let payLoad = { mobile: username, password: password };
            const res = await httpClient.post(PARTNER_LOGIN, payLoad);         
            if (res.requestStatus === 'OK') {
                const result = res.result;
                if (result.status === 1) {
                    localStorage.setItem('token', result.data.token);
                    dispatch(login(res));
                    Alert.success(result.message);
                    navigate('/root');
                } else {                  
                    Alert.error(result.message);
                }
            } 
        }
        setErrors(formErrors);
    }

    return (
        <div className="container-scroller">
            <div className="container-fluid page-body-wrapper full-page-wrapper">
                <div className="content-wrapper d-flex align-items-center auth px-0">
                    <div className="row w-100 mx-0">
                        <div className="col-lg-4 mx-auto  zoom-in">
                            <div className="auth-form-light text-left py-5 px-4 px-sm-5">
                                <div className="brand-logo text-center">
                                    <img src={logo} alt="logo" />
                                </div>
                                <h4>{t('hello_lets_get_started')}</h4>
                                <h6 className="font-weight-light">{t('sign_in_to_continue')}</h6>
                                {errors.httpError && <p style={{ color: "red" }}>{errors.httpError}</p>}
                                <form className="pt-3" onSubmit={(e) => handelSubmit(e)}>
                                    <div className="form-group">
                                        <input
                                            type="text"
                                            className="form-control form-control-lg"
                                            id="username"
                                            name='username'
                                            autoComplete="true"
                                            onChange={(e) => setUsername(e.target.value)}
                                            placeholder={t('username')} />
                                        {errors.username && <p style={{ color: "red" }}>{t(errors.username)}</p>}
                                    </div>
                                    <div className="form-group">
                                        <input
                                            autoComplete="true"
                                            type="password"
                                            className="form-control form-control-lg"
                                            id="exampleInputPassword1"
                                            name='password'
                                            onChange={(e) => setPassword(e.target.value)}
                                            placeholder={t('password')} />
                                        {errors.password && <p style={{ color: "red" }}>{t(errors.password)}</p>}
                                    </div>
                                    <div className="mt-3">
                                        <button className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn" type='submit'>{t('login')}</button>
                                    </div>
                                    <div className="my-2 d-flex justify-content-between align-items-center">
                                        <div className="form-check">
                                            <label className="form-check-label text-muted">
                                                <input type="checkbox" className="form-check-input" />
                                                {t('keep_me_signed_in')}
                                            </label>
                                        </div>
                                        <Link to={"/"} className="auth-link text-black">{t('forget_password')}</Link>
                                    </div>
                                    <div className="text-center mt-4 font-weight-light">
                                    {t('dont_have_account')} <Link to={"/"} className="text-primary">{t('create')}</Link>
                                    </div>
                                </form>
                            </div>
                        </div>                        
                    </div>
                </div>
            </div>
        </div>
    )
}
